import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'
import Arrow from 'react-feather/dist/icons/arrow-right'
import LinkIcon from 'react-feather/dist/icons/link-2'

const Action = () => (
  <Wrapper>
    {/* <div className="fakebar" /> */}
    <div className="container">
      <h3>Ready to start creating?</h3>
      <a className="btn" href="https://app.shotsnapp.com">
        Let's go <Arrow color="#333" size={22} />
      </a>
    </div>
  </Wrapper>
)

export default Action

const Wrapper = styled.div`
  text-align: center;
  padding: 80px 0;
  position: relative;
  overflow: hidden;

  .container {
  }
  h3 {
    width: 95%;
    color: #fff;
    max-width: 500px;
    font-size: 30px;
    margin: 5px auto 30px;
    line-height: 1.25;
    @media (max-width: 600px) {
      font-size: 34px;
    }
  }
  a.btn {
    padding: 14px 28px;
    background-color: #fff;
    color: #333;
    font-size: 20px;
    display: inline-block;
    border-radius: 5px;
    text-decoration: none;
    transition: all 0.1s ease-out;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);

    svg {
      vertical-align: -4px;
      margin-left: 5px;
      transition: all 0.1s ease-out;
    }
    &:hover {
      position: relative;
      svg {
        position: relative;
        transform: translate3d(3px, 0, 0);
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/Action.js